//====================================================
//  Function: Reposition Products
//====================================================

function componentsRepositionProducts() {
  if ($(".products-block").length) {
    partsRepositionProducts();
    addImageBadgeProduct();
    addBadgePexesoProduct();
  }
}

function partsRepositionProducts() {
  if ($(".products-block").length) {
    repositionProductElements($(".products-block .product"));
  }
}

function repositionProductElements($products) {
  if (!$products || !$products.length) return;

  $products.each(function () {
    var product = $(this);
    var productAvailability = product.find(".availability");
    var productImage = product.find(".image");
    var productPIn = product.find(".p-in");
    var productPriceStandard = product.find(".price-standard");
    var productSave = product.find(".price-save").text();

    if (product.find(".flags-default").length == 0) {
      productImage.prepend('<div class="flags flags-default"></div>');
    }

    if (product.find(".flag-viac_farieb").length > 0) {
      productPIn.append(product.find(".flag-viac_farieb"));
    }

    if (
      product.find(".flag-discount").length > 0 &&
      product.find(".flags-default .flag-discount").length == 0
    ) {
      var productFlagsDefault = product.find(".flags-default");
      productFlagsDefault.append(
        '<div class="flag flag-discount"><div class="price-save">' +
          productSave +
          "</div></div>"
      );
    }

    product.find(".p-tools").append(productAvailability);
    product.find(".price-final").append(productPriceStandard);
  });
}

function addMOCLabelProduct() {
  var labelText, prefixText;
  
  switch(lang) {
    case 'sk':
      labelText = "MOC";
      prefixText = "od ";
      break;
    case 'hu':
      labelText = "kisker ár";
      prefixText = "-tól";
      break;
    case 'cs':
      labelText = "MOC";
      prefixText = "od ";
      break;
    case 'ro':
      labelText = "PRP";
      prefixText = "de la ";
      break;
    default:
      return;
  }
  
  $(".p[data-micro='product']").each(function () {
    var $product = $(this);
    if ($product.find(".moc-label").length > 0) return;
    
    var $mocPriceElement = $product.find(".w-moc-price");
    if ($mocPriceElement.length === 0 || $mocPriceElement.find("span").length === 0) return;
    
    var $priceSpans = $mocPriceElement.find("span");
    var mocPrice;
    
    if ($priceSpans.length > 1) {
      var lowestNum = null;
      var lowestText = "";
      $priceSpans.each(function() {
        var priceText = $(this).text().trim();
        var num = parseFloat(priceText.replace(/[^\d\.]/g, ''));
        if (!isNaN(num) && (lowestNum === null || num < lowestNum)) {
          lowestNum = num;
          lowestText = priceText;
        }
      });
      // for HU add the prefix after the price
      if (lang === 'hu') {
        mocPrice = lowestText + prefixText;
      } else {
        mocPrice = prefixText + lowestText;
      }
    } else {
      mocPrice = $priceSpans.first().text().trim();
    }
    
    if (!mocPrice) return;
    
    var $pricesContainer = $product.find(".prices");
    if ($pricesContainer.length > 0) {
      $pricesContainer.find(".moc-label").remove();
      var $mocWrapper = $("<div class='moc-label'></div>");
      var $labelSpan = $("<span class='moc-label-text'>" + labelText + " </span>");
      var $priceSpan = $("<span class='moc-price'>" + mocPrice + "</span>");
      
      $mocWrapper.append($labelSpan).append($priceSpan);
      $pricesContainer.prepend($mocWrapper);
    }
  });
}

function initYotpoCategoryStars() {
  if ( typeof yotpoWidgetStars === 'undefined' ) return;

  $('.product').each(function () {
    const $product = $(this);
    const sku = $product.find('span[data-micro="sku"]').text().trim().replace(/\//g, '_');
    const $tools = $product.find('.p-tools');
    if (!sku || !$tools.length) return;

    const existingWidget = $tools.find(`.yotpo-widget-instance[data-yotpo-product-id="${sku}"]`);
    if (existingWidget.length) return;

    const $widget = $(`<div class="yotpo-widget-instance" style="display: none;" data-yotpo-instance-id="${yotpoWidgetStars}" data-yotpo-product-id="${sku}"></div>`);
    $tools.append($widget);

    let tries = 0;
    const maxTries = 30;

    const interval = setInterval(() => {
      const $textEl = $widget.find('.yotpo-sr-bottom-line-text');
      const text = $textEl.text().trim();
      const count = parseInt(text.replace(/[^\d]/g, ''), 10);

      if (!isNaN(count)) {
        if (count > 0) {
          $widget.css('display', 'flex'); 
        } else {
          $widget.hide();
        }
        clearInterval(interval);
      }

      if (++tries >= maxTries) clearInterval(interval);
    }, 400);
  });
}

function addImageBadgeProduct() {
  // ak nie je definovaný jazyk alebo badge dáta, nespustíme funkciu
  if (!lang || typeof flagImages === 'undefined') return;

  $('.product').each(function () {
    const $product = $(this);
    const $flags = $product.find('.flags');
    const $imageWrapper = $product.find('.image').first();

    if (!$flags.length || !$imageWrapper.length) return;

    const $allFlags = $flags.find('.flag');

    // Zoradíme všetky flagy podľa priority (gift1 > gift2/3 > badge)
    const sortedFlags = $allFlags.toArray().sort((a, b) => {
      const getPriority = (el) => {
        const cls = Array.from(el.classList).find(c =>
          c.startsWith('flag-gift-') || c.startsWith('flag-badge-')
        );
        if (!cls) return 99;
        if (cls === 'flag-gift-1') return 1;
        if (cls.startsWith('flag-gift-')) return 2;
        if (cls.startsWith('flag-badge-')) return 3;
        return 99;
      };
      return getPriority(a) - getPriority(b);
    });

    for (const flagEl of sortedFlags) {
      const classList = Array.from(flagEl.classList);
      const badgeClass = classList.find(cls =>
        (cls.startsWith('flag-badge-') || cls.startsWith('flag-gift-')) &&
        classList.includes('flag')
      );

      if (!badgeClass) continue;
      if ($imageWrapper.find(`.product-badge-img.${badgeClass}`).length) continue;

      const badgeEntry = flagImages[badgeClass];
      if (!badgeEntry) break;

      const imgUrl = badgeEntry[lang];
      if (!imgUrl || imgUrl.trim() === '') break;

      const $badgeImg = $('<img>', {
        src: imgUrl,
        alt: badgeClass,
        class: `product-badge-img ${badgeClass}`,
        loading: 'lazy',
      });

      $imageWrapper.append($badgeImg);
      break; // zobrazíme len jeden badge podľa priority
    }
  });
}

function addBadgePexesoProduct() {
  var products = document.querySelectorAll('.product');
  if (!products.length) return;

  var imgSrc;

  switch (lang) {
    case 'sk':
      imgSrc = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsk/badge-pexeso.png';
      break;
    case 'hu':
      imgSrc = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whu/badge-pexeso.png';
      break;
    case 'cs':
      imgSrc = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wcz/badge-pexeso.png';
      break;
    case 'ro':
      imgSrc = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wro/badge-pexeso.png";
      break;
    case 'hr':
      imgSrc = "https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/whr/badge-pexeso.png";
      break;
    case 'sl':
      imgSrc = 'https://cdn.myshoptet.com/usr/www.wilsondo.cz/user/documents/template/images/shop-name/wsi/badge-pexeso.png';
      break;
    default:
      return;
  }

  for (var i = 0; i < products.length; i++) {
    var product = products[i];

    var productImage = product.querySelector('.image');
    if (!productImage) continue;

    // ak je GIFT badge, pexeso vôbec nepridávame
    var giftBadge = productImage.querySelector('.product-badge-img[class*="flag-gift-"]');
    if (giftBadge) continue;

    // len produkty s flag-xy-discount
    var hasBadgeFlag = product.querySelector('.flag.flag-xy-discount');
    if (!hasBadgeFlag) continue;

    // ak je tam len BADGE (flag-badge-XXX), skryjeme ho
    var normalBadges = productImage.querySelectorAll('.product-badge-img[class*="flag-badge-"]');
    normalBadges.forEach(function (badge) {
      badge.style.display = 'none';
    });

    var img = document.createElement('img');
    img.className = 'product-badge-img';
    img.src = imgSrc;
    img.alt = 'Pexeso';

    productImage.appendChild(img);
  }
}

// Low-priority promotional badge (flag-badge-5) — JS-only, never assigned in admin.
// Renders only when no other gift/badge/pexeso is on the product image and the
// displayed price is above a per-language threshold. Toggle via SHOPNAME.
function addBadge5LowPriorityProduct() {

  if (!lang || typeof flagImages === 'undefined') return;

  var badgeEntry = flagImages['flag-badge-5'];
  if (!badgeEntry) return;
  var imgUrl = badgeEntry[lang];
  if (!imgUrl || !imgUrl.trim()) return;

  // Price threshold is configured per page in admin, e.g.:
  // var addBadge5MinPrice = 300;
  var threshold = parseFloat(window.addBadge5MinPrice);
  if (!isFinite(threshold)) return;

  // Scope to standard listing cards only — mini cards (recently viewed,
  // cross-sell mini widgets) use a different layout where .image has no
  // positioning context, so an appended .product-badge-img would render
  // inline rather than overlaid on the photo.
  $('.products-block .product').each(function () {
    var $product = $(this);
    var $imageWrapper = $product.find('.image').first();
    if (!$imageWrapper.length) return;

    // Lowest priority — skip if any other badge/gift/pexeso already rendered.
    if ($imageWrapper.find('.product-badge-img').length) return;

    var priceAttr = $product.find('[data-micro-price]').first().attr('data-micro-price');
    var price = parseFloat(priceAttr);
    if (!isFinite(price) || price <= threshold) return;

    var $badgeImg = $('<img>', {
      src: imgUrl,
      alt: 'flag-badge-5',
      class: 'product-badge-img flag-badge-5',
      loading: 'lazy',
    });
    $imageWrapper.append($badgeImg);
  });
}
